import {createContext} from 'react'
import {ModalLimitedAccessHandler} from 'types'

export const ModalLimitedAccessContext = createContext<
  ModalLimitedAccessHandler | undefined
>(undefined)
